import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const CopyIcon = (properties: iconType) => {
  const { width, height } = properties;
  return (
    <SvgIcon
      {...properties}
      viewBox="0 0 19 24"
      style={{
        fill: 'none',
        width: `${width || '16px'}`,
        height: `${height || '20px'}`,
      }}
    >
      <path d="M1.95 4C1.4275 4 1 4.43548 1 4.96774V21.7419C1 22.2742 1.4275 22.7097 1.95 22.7097H14.6167C15.1392 22.7097 15.5667 22.2742 15.5667 21.7419V11.3065C15.5667 11.0484 15.4717 10.8065 15.2817 10.629L9.05917 4.29032C8.885 4.09677 8.6475 4 8.39417 4H1.95Z" />
      <path d="M4 3V1.96774C4 1.43548 4.4275 1 4.95 1H11.3942C11.6475 1 11.885 1.09677 12.0592 1.29032L18.2817 7.62903C18.4717 7.80645 18.5667 8.04839 18.5667 8.30645V18.7419C18.5667 19.2742 18.1392 19.7097 17.6167 19.7097H17" />
    </SvgIcon>
  );
};

CopyIcon.defaultProperties = {
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#0000008a',
  strokeWidth: '2',
};

export default CopyIcon;
